import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "_grid _grid-cols-1 _grid-cols-2--m _gap-2" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  class: "_tc--light",
  "data-qa": "field-label-text"
}
const _hoisted_4 = {
  key: 1,
  class: "_flex _ai-c _order-3--m _col-span-2--m"
}
const _hoisted_5 = { class: "gfu-bt--caption" }
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 2,
  class: "_order-2--l"
}
const _hoisted_8 = {
  class: "_tc--light",
  "data-qa": "field-label-text"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_field_label = _resolveComponent("field-label")
  const _component_language_selector = _resolveComponent("language-selector")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_localize = _resolveComponent("localize")
  const _component_theme_selector = _resolveComponent("theme-selector")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($options.isLanguageSelectorVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_language_selector, {
            "display-name": _ctx.Resources.Layout.LanguageSelectorModalLabel,
            "has-transparent-bg": true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_field_label, { class: "_mb-1" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.Resources.Layout.LanguageSelectorModalLabel), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["display-name"])
        ]))
      : _createCommentVNode("v-if", true),
    ($options.isLanguageSelectorVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_base_icon, {
            size: "lg",
            class: "_pr-2",
            name: "lightbulb"
          }),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_localize, {
              resource: _ctx.Resources.Layout.LanguageDropdownReportTranslationIssueParagraph
            }, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  "format-key": "0",
                  href: $options.contactTranslationUrl,
                  "data-qa": "footer-translation-issue-report-link"
                }, _toDisplayString(_ctx.Resources.Layout.LanguageDropdownReportTranslationIssueLink), 9 /* TEXT, PROPS */, _hoisted_6)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["resource"])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    ($options.isDarkModeEnabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_theme_selector, { "has-transparent-bg": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_field_label, { class: "_mb-1" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.Resources.Layout.ThemeSelectorLabel), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}